export const url = (_url) => `url("${_url}")`;
export const rgba = (...params) => `rgba(${params.join(", ")})`;
export const flex = "flex";
export const column = "column";
export const cover = "cover";
export const overlay = "overlay";
export const center = "center";
export const row = "row";
export const spaceBetween = "space-between";
